import { useNavigate } from 'react-router-dom';

import usePrepareLink from './usePrepareLink';

export interface NavigateToLinkData {
  to?: string;
  query?: Record<string, string>;
  state?: Record<string, any>;
  keepOldQuery?: boolean;
  keepOldState?: boolean;
  keepOldPathname?: boolean;
  params?: Record<string, string | null | undefined>;
}

export type NavigateToFunction = (data: NavigateToLinkData) => void;

/**
 * @deprecated Use 'useNavigate' hook from react router library
 */
export function useNavigateTo(): NavigateToFunction {
  const navigate = useNavigate();
  const prepareLink = usePrepareLink();

  return (data: NavigateToLinkData): void => {
    const link = prepareLink(data);
    const { state, ...to } = link;
    navigate(to, { state, replace: false });
  };
}
